import React, { useEffect, useState, useRef } from 'react';
import { useInView } from 'framer-motion';
import { getContent } from '../utils/contentStore';
import { useLanguage } from '../utils/i18n';
interface StatProps {
  value: string;
  label: string;
  delay?: number;
}
function AnimatedStat({
  value,
  label,
  delay = 0
}: StatProps) {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true
  });
  const [displayed, setDisplayed] = useState('0');
  useEffect(() => {
    if (!isInView) return;
    const numericMatch = value.match(/(\d+)/);
    if (!numericMatch) {
      setDisplayed(value);
      return;
    }
    const target = parseInt(numericMatch[1], 10);
    const suffix = value.replace(numericMatch[1], '');
    const duration = 1800;
    const startTime = Date.now() + delay * 1000;
    let frame: number;
    const animate = () => {
      const now = Date.now();
      if (now < startTime) {
        frame = requestAnimationFrame(animate);
        return;
      }
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(eased * target);
      setDisplayed(`${current}${suffix}`);
      if (progress < 1) frame = requestAnimationFrame(animate);
    };
    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, [isInView, value, delay]);
  return <div ref={ref} className="p-4 text-center" data-id="element-376">
      <div className="font-heading text-5xl md:text-7xl font-bold mb-2 tabular-nums text-white" data-id="element-377">
        {displayed}
      </div>
      <div className="text-gray-400 uppercase tracking-wider text-sm font-medium" data-id="element-378">
        {label}
      </div>
    </div>;
}
export function StatsSection() {
  const stats = getContent().stats;
  const {
    loc
  } = useLanguage();
  return <div className="bg-gray-900 py-16 text-white" data-id="element-379">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl" data-id="element-380">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 divide-x divide-white/10" data-id="element-381">
          {stats.map((stat, index) => <AnimatedStat key={index} value={loc(stat.value)} label={loc(stat.label)} delay={stat.delay} data-id="element-382" />)}
        </div>
      </div>
    </div>;
}